import { CurrencyPipe, DatePipe } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { MatDivider } from "@angular/material/divider";
import { FlexDirective, FlexOffsetDirective, LayoutAlignDirective, LayoutDirective } from "@ngbracket/ngx-layout/flex";
import { PurchaseOrderInvoiceViewModel } from "@tylertech/tyler-api-types";

@Component({
    selector: "po-receipt-detail",
    templateUrl: "./poReceiptDetail.tmpl.html",
    styleUrls: [
        "./poReceiptDetail.component.scss"
    ],
    imports: [
        CurrencyPipe,
        DatePipe,
        FlexDirective,
        FlexOffsetDirective,
        LayoutAlignDirective,
        LayoutDirective,
        MatDivider,
    ]
})
export class PoReceiptDetailComponent implements OnInit
{
    private readonly detailByVendor = new Map<string, Array<PurchaseOrderInvoiceViewModel>>();

    @Input()
    detail: PurchaseOrderInvoiceViewModel[];

    grandTotal: number = 0;

    ngOnInit(): void
    {
        this.detail.forEach(element =>
        {
            if (!this.detailByVendor.has(element.VendorName))
            {
                this.detailByVendor.set(element.VendorName, []);
            }
            this.detailByVendor.get(element.VendorName).push(element);
            this.grandTotal += element.Amount;
        });
    }

    getVendors(): Array<string>
    {
        return Array.from(this.detailByVendor.keys());
    }

    getInvoices(vendorName: string): Array<PurchaseOrderInvoiceViewModel> | undefined
    {
        return this.detailByVendor.get(vendorName);
    }
}
